package com.schoolconnect.app.feature.calendar

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun CalendarFeatureRoute(
    onBack: () -> Unit
) {
    val viewModel = remember { CalendarViewModel() }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    CalendarScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack,
        contextLine = "School calendar | 2026–27"
    )
}
